import * as React from 'react'
import cn from 'classnames'

export type CycleScope = 'active' | 'archived'

type ScopeSelectorProps = {
  value: CycleScope
  activeCount: number
  archivedCount: number
  onChange: (scope: CycleScope) => void
}

const TABS: Array<{ scope: CycleScope; label: string }> = [
  { scope: 'active', label: 'Actives' },
  { scope: 'archived', label: 'Archives' },
]

export const ScopeSelector = ({
  value,
  activeCount,
  archivedCount,
  onChange,
}: ScopeSelectorProps) => {
  const counts: Record<CycleScope, number> = {
    active: activeCount,
    archived: archivedCount,
  }

  return (
    <div className="inline-flex items-center gap-1 rounded-xl bg-[#F4F5F8] p-1">
      {TABS.map(({ scope, label }) => {
        const isActive = value === scope

        return (
          <button
            key={scope}
            type="button"
            onClick={() => onChange(scope)}
            aria-current={isActive ? 'page' : undefined}
            className={cn(
              'inline-flex items-center gap-2 rounded-lg px-4 py-2 text-base font-medium transition-colors',
              isActive
                ? 'bg-white text-[#1D264A] shadow-sm'
                : 'text-gray-500 hover:text-[#1D264A]'
            )}
          >
            {label}
            <span className="inline-flex min-w-[20px] items-center justify-center rounded-md bg-[#E5E7EB] px-1.5 text-sm font-medium text-[#1D264A]">
              {counts[scope]}
            </span>
          </button>
        )
      })}
    </div>
  )
}
